import React from 'react';

import { FastshiftRunbookStep } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { useIntl } from 'react-intl';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import FlagFilledIcon from '@atlaskit/icon/core/flag-filled';
import ProblemIcon from '@atlaskit/icon/core/problem';
import { Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { messages } from '../messages';

import { isRunbookStepDone } from './runbook-step-list-utils';

const stepIconContainerStyles = xcss({
	flexShrink: 0,
});

export type RunbookStepStatusIconsProps = {
	step: FastshiftRunbookStep;
};

export const RunbookStepStatusIcons: React.FC<RunbookStepStatusIconsProps> = ({ step }) => {
	const intl = useIntl();

	if (!step.disabled && !step.risk && !isRunbookStepDone(step)) {
		return null;
	}

	const disabledLabel = intl.formatMessage(messages.runbooksPanelStepDisabledIconLabel);
	const riskLabel = intl.formatMessage(messages.runbooksPanelStepRiskIconLabel);
	const doneLabel = intl.formatMessage(messages.runbooksPanelStepDoneIconLabel);

	return (
		<Inline alignBlock="start" alignInline="end" space="space.075" xcss={stepIconContainerStyles}>
			{step.disabled && (
				<Tooltip content={disabledLabel}>
					<ProblemIcon label={disabledLabel} color={token('color.icon.subtle')} />
				</Tooltip>
			)}
			{step.risk && (
				<Tooltip content={riskLabel}>
					<FlagFilledIcon label={riskLabel} color={token('color.icon.danger')} />
				</Tooltip>
			)}
			{isRunbookStepDone(step) && (
				<Tooltip content={doneLabel}>
					<CheckCircleIcon label={doneLabel} color={token('color.icon.success')} />
				</Tooltip>
			)}
		</Inline>
	);
};
